import { upload_class_max_benefit_file } from "../../../../../../api/employerService.js"
import { MAX_BENEFIT_AGE_LIST } from "../../../../../../legacyComponents/util/api/apis/employer/PermissibleClass/constants";

export default async function uploadAllowances(props, file, setData, employer) {
	let { formik } = props
	let values = {} ;
	let setValues = ()=>{};
	if(formik) {
	 	values = formik?.values;
		setValues = formik?.setValues;
	}

	const benefits = [
		{ type: "SELF", formKey: "selfAmount" },
		{ type: "SPOUSE", formKey: "spouseAmount" },
		{ type: "CHILDREN", formKey: "childAmount" },
		{ type: "SPOUSE_CHILDREN", formKey: "allAmount" }
	]

	const response = await upload_class_max_benefit_file(employer?.id, file);
	const maxBenefit = response?.data
	const selfBenefit = maxBenefit?.SELF;
	values = structuredClone(values)

	for (let age = MAX_BENEFIT_AGE_LIST.MINIMUM_AGE; age <= MAX_BENEFIT_AGE_LIST.MAXIMUM_AGE; age++) {
		const key = `amount${age}`

	for (let { type, formKey } of benefits) {
            formKey = `${formKey}${age}`
            /**
             * Backend sends ANNUAL CENTS; the form holds MONTHLY DOLLARS.
             *
             * Rounded to whole cents so the stored value matches what the
             * table renders. An annual figure not divisible by 12 would
             * otherwise land in the form as e.g. 83.33333333333333 while
             * displaying as $83.33 — validation would then be checking a
             * number the user cannot see.
             */
            const annualCents = maxBenefit?.[type]?.[key] || 0
			// Annual cents, as stored. Converted to monthly dollars at display.
			values[formKey] = maxBenefit?.[type]?.[key] || 0        }
	}
	if(setData != undefined && setData != null){
		setData(selfBenefit)
	}
	if(setValues != undefined && setValues != null){
		setValues(values)
	}
	return maxBenefit
}
